const LOADING_CLASS_NAME = 'loading';

module.exports = () => {
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form');

    if (!form) {
      return;
    }

    const input = form.querySelector('input[data-is-grecaptcha-input]');
    const action = input && input.dataset.grecaptchaAction;
    const key = input && input.dataset.grecaptchaKey;

    if (
      input
      && action
      && key
      && typeof grecaptcha !== 'undefined'
      && typeof grecaptcha.execute !== 'undefined'
    ) {
      event.preventDefault();

      if (form.classList.contains(LOADING_CLASS_NAME)) {
        return;
      }

      form.classList.add(LOADING_CLASS_NAME);
      grecaptcha.execute(key, { action })
        .then((token) => {
          input.value = token;
          form.submit();
          form.classList.remove(LOADING_CLASS_NAME);
        })
        .catch((error) => {
          console.log(error);
          alert('Ошибка при отправке формы, пожалуйста, попробуйте снова');
          form.classList.remove(LOADING_CLASS_NAME);
        });
    }
  });
};



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/form-grecaptcha.js
 **/